// extracted by mini-css-extract-plugin
export var active = "TableOfContents-module--active--d1829";
export var item = "TableOfContents-module--item--9cd78";
export var list = "TableOfContents-module--list--56d32";
export var nested = "TableOfContents-module--nested--c0a6b";
export var nestedList = "TableOfContents-module--nestedList--d7554";
export var title = "TableOfContents-module--title--5c9e8";
export var toc = "TableOfContents-module--toc--b00b1";